import { VText } from '@vake/ui-kit';
import { FC, useEffect, useState } from 'react';
import { hotjar } from 'react-hotjar';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../../auth/AuthProvider';
import { useIsAdmin } from '../../requests/reports';
import { getConsentCookie, setConsentCookie } from '../../utils/cookies';
import { Button } from '../styles/Buttons';

const Wrapper = styled.div`
    position: fixed;
    z-index: 10000;
    bottom: 0px;
    width: 100vw;
    color: black;
`;

const Banner = styled.div`
    background: #e7e7e7;
    margin: auto;
    width: calc(100% - 30px);
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    a {
        color: black;
    }
`;
const StyledButton = styled(Button)`
    background: rgba(0, 0, 0, 0.1);
    border: 2px solid black;
    color: black;
    padding: 5px 10px;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const ButtonWrapper = styled.div`
    display: flex;
    button {
        margin-left: 10px;
    }
`;

export const CookieConsent: FC = () => {
    const { token } = useAuth();
    const { data: isAdmin } = useIsAdmin(token);
    const [visible, setVisible] = useState(true);
    const [consented, setConsented] = useState(getConsentCookie());

    const handleConsentClick = () => {
        setConsented(true);
        setConsentCookie();
    };

    useEffect(() => {
        if (consented) {
            hotjar.initialize(2236246, 6);
        }
    }, [consented]);

    if (!visible || consented || isAdmin) {
        return null;
    }
    return (
        <Wrapper>
            <Banner>
                <VText significance="quaternary">
                    We use{' '}
                    <Link to="/privacy-policy" className="underline">
                        cookies
                    </Link>{' '}
                    to keep you logged in and to analyze product usage
                </VText>
                <ButtonWrapper>
                    <StyledButton onClick={() => setVisible(false)}>Decline</StyledButton>
                    <StyledButton onClick={handleConsentClick}>Accept</StyledButton>
                </ButtonWrapper>
            </Banner>
        </Wrapper>
    );
};
